//#region src/resolver.ts
const devFeatureFlagKey = (key, prefix) => {
	if (!/^[A-Za-z0-9._-]+$/.test(prefix)) throw new Error(`Invalid feature flag development prefix: ${prefix}`);
	return `${prefix}-${key}`;
};
function createFeatureFlagResolver({ source, devKeyPrefix }) {
	const resolve = (key) => {
		const candidateKeys = devKeyPrefix ? [devFeatureFlagKey(key, devKeyPrefix), key] : [key];
		for (const candidateKey of candidateKeys) {
			const value = source.getFeatureFlag(candidateKey);
			if (value !== void 0) return {
				key: candidateKey,
				value
			};
		}
		return {
			key,
			value: void 0
		};
	};
	return {
		isEnabled: (key) => Boolean(resolve(key).value),
		getVariant: (key) => {
			const { value } = resolve(key);
			return typeof value === "string" ? value : "";
		},
		getPayload: (key) => {
			const payload = source.getFeatureFlagPayload(resolve(key).key);
			return payload === void 0 || payload === null ? void 0 : payload;
		}
	};
}
//#endregion
//#region src/refresh-window.ts
const DEFAULT_FEATURE_FLAG_TTL_MS = 36e5;
const DEFAULT_FEATURE_FLAG_RETRY_MS = 6e4;
function createFeatureFlagRefreshWindow({ ttlMs = DEFAULT_FEATURE_FLAG_TTL_MS, retryMs = DEFAULT_FEATURE_FLAG_RETRY_MS, now = Date.now } = {}) {
	let loadedAt = -Infinity;
	let requestedAt = -Infinity;
	return {
		claimRefresh: () => {
			if (now() - loadedAt < ttlMs || now() - requestedAt < retryMs) return false;
			requestedAt = now();
			return true;
		},
		markLoaded: () => {
			loadedAt = now();
		},
		invalidate: () => {
			loadedAt = -Infinity;
			requestedAt = -Infinity;
		}
	};
}
//#endregion
export { DEFAULT_FEATURE_FLAG_RETRY_MS, DEFAULT_FEATURE_FLAG_TTL_MS, createFeatureFlagRefreshWindow, createFeatureFlagResolver, devFeatureFlagKey };

//# sourceMappingURL=index.js.map